import React, {useState} from "react";
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    Col,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Row
} from "reactstrap";
import LocalizedStrings from "react-localization";
import {common_strings} from "../../translations/common_translations";
import businessHelper from "../../helpers/BusinessHelper";
import lsHelpers from "../../helpers/LsHelper";
import businessApiService from "../../api/business-api-service";
import {Redirect} from "react-router-dom";
import Select from "react-select";
import dateHelpers from "../../helpers/DateHelper";
import ErrorModal from "../../components/Alerts/ErrorModal";
import LanguagePanel from "../../components/utils/LanguagePanel";

import {useObservable} from "../../components/utils/observable/observableHook";
import {bTypeService, localeService} from "../../components/utils/observable/services";
import {RotateCircleLoading} from "react-loadingg";
import LoadingOverlay from "react-loading-overlay";
import ClientAppComponent from "../../components/Alerts/ClientAppComponent";
import clientHelper from "../../helpers/ClientHelper";
import AppModal from "../../components/Alerts/AppModal";

let commonStrings = new LocalizedStrings(common_strings);

const RegisterF = (props) => {

    const locale = useObservable(localeService.locale);

    const [error, setError] = useState(null);
    const [accountType, setAccountType] = useState("b");
    const [showError, setShowError] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [toDashboard, setToDashboard] = useState(false);
    const [toPasswordReset, setToPasswordReset] = useState(false);
    const [toLogin, setToLogin] = useState(false);
    const [toDiscover, setToDiscover] = useState(false);
    const [toBusiness, setToBusiness] = useState(false);
    const [bType, setBType] = useState(businessHelper.businessTypes()[0]);
    const [showMobile, setShowMobile] = useState(false);

    const [validation, setValidation] = useState({
        name: true,
        email: true,
        password: true,
    });
    const [formData, setFormData] = useState({email: '', password: '', name: '', ppConfirmed: false});

    function handleNetworkError(e) {
        setError(e);
        setShowError(true);
        setLoading(false);
    }

    // useEffect(() => {
    //     handleValidation();
    // }, [validation]);

    function handleValidation() {
        setValidation({
            name: formData.name.length > 1,
            email: emailIsValid(),
            password: formData.password.length > 2,
        });
    };

    function emailIsValid() {
        const e = formData.email;
        return e.length > 5 && e.includes("@") && e.includes(".") && e.length - e.indexOf(".") > 2
    };

    function saveUserSession(data) {
        businessHelper.saveUserSession(data);
        lsHelpers.createDatesRecord();
    };

    function handleChange(event) {
        let newValue = event.target.value;
        let checked = event.target.checked;

        const f = formData;

        if (event.target.id === 'input-email') {
            f.email = newValue;
        } else if (event.target.id === 'input-password') {
            f.password = newValue;
        } else if (event.target.id === 'input-name') {
            f.name = newValue;
        } else if (event.target.id === 'input-pp-cb') {
            f.ppConfirmed = checked;
        }

        setFormData(f);
        handleValidation();
    }

    function handleSubmit(event) {
        event.preventDefault();
        register();
    }

    function validationCleared() {
        return Object.values(validation).every(item => item)
    }

    function setMustShowWelcome() {
        lsHelpers.resetWelcomeShown();
        lsHelpers.setMustShowWelcome()
    }

    function register() {
        setLoading(true);
        const at = accountType == "c" ? "c" : null

        const data = {
            name: formData.name,
            email: formData.email,
            password: formData.password,
            password_confirmation: formData.password,
            timestamp: dateHelpers.databaseDateTime(new Date()),
            b_type: formData.b_type,
            locale: locale,
            user_type: at
        };

        businessApiService.register(data)
            .then(res => {
                setMustShowWelcome()
                saveUserSession(res);
                login()
            })
            .catch((e) => {
                handleNetworkError(e)
            });
    }

    function login() {
        businessApiService.login(formData.email, formData.password)
            .then(res => {
                if ( accountType != "c" && !businessHelper.isClientAccount(res)) {
                    saveUserSession(res);
                    setToDashboard(true)
                } else {
                    if (accountType == "c") {
                        clientHelper.saveUserSession(res)
                        if (res.user && res.user.business_id && res.user.business_id > 0) {
                            setToBusiness(true)
                        } else {
                            setToDiscover(true)
                        }
                    }
                    else {
                        showIsClientModal()
                    }
                }
            })
            .catch((e) => {
                handleNetworkError(e)
            });
    }

    const handleTypeSelected = selectedOption => {
        const f = formData;
        setBType(selectedOption);
        bTypeService.setBType(selectedOption.value)
        f.b_type = selectedOption.value;
        setFormData(f);
    };

    function toggleErrorModal() {
        setError(null);
        setShowError(false);
    }

    function onLanguageChanged(locale) {
        localeService.setLocale(locale);
    }

    localize();

    if (toDashboard === true) {
        return <Redirect from="*" to="/admin/index"/>
    }

    function goToPasswordReset(e) {
        e.preventDefault();
        setToPasswordReset(true)
    }

    function goToLogin(e) {
        e.preventDefault();
        setToLogin(true)
    }

    if (toLogin === true) {
        return <Redirect from="*" to="/auth/login"/>
    }

    if (toPasswordReset === true) {
        return <Redirect from="*" to="/auth/password_reset"/>
    }

    function businessButtonColor() {
        return accountType === "b" ? "yellowopen" : "secondary";
    }

    function clientButtonColor() {
        return accountType === "c" ? "yellowopen" : "secondary";
    }

    function setType(e, type) {
        e.preventDefault();
        setAccountType(type);
    }

    function goToPP() {
        window.open("https://app.openmanagerapp.com/privacypolicy", "_blank")
    }

    if (toBusiness == true) {
        return <Redirect from="*" to="/client/business"/>
    }

    if (toDiscover == true) {
        return <Redirect from="*" to="/client/discover"/>
    }

    function showIsClientModal() {
        alert(commonStrings.client_account_warning)
    }

    function downloadApp(e) {
        e.preventDefault();
        // window.location.replace("https://0zlz8.app.link/mId9S8KAghb")
        setShowMobile(true)
    }

    const toggleMobileModal = () => {
        setShowMobile(!showMobile)
    };

    return (
        <>

            {showError &&
            <ErrorModal showError={showError} error={error}
                        toggleErrorModal={toggleErrorModal}/>
            }

            {showMobile &&
            <AppModal toggleAppModal={toggleMobileModal} showAppModal={showMobile}/>
            }

            <Col lg="6" md="8" className="mt--100">
                <LoadingOverlay
                    active={isLoading}
                    spinner={<RotateCircleLoading color="white"/>}
                    text=''
                >
                    <Card className="bg-secondary shadow border-0">
                        <Row className="align-content-center"
                             style={{marginTop: "-50px", marginLeft: "6px"}}>
                            <LanguagePanel onResult={onLanguageChanged}/>
                        </Row>
                        <CardBody className="px-lg-5 py-5">
                            <Row className="align-content-center text-center mb-2">
                                <Col>
                                    <Button
                                        color={businessButtonColor()} style={{width: "100%"}}
                                        onClick={e => setType(e, "b")}
                                    >
                                        {commonStrings.type_business}
                                    </Button>
                                </Col>
                                <Col>
                                    <Button
                                        color={clientButtonColor()} style={{width: "100%"}}
                                        onClick={e => setType(e, "c")}
                                    >
                                        {commonStrings.type_client}
                                    </Button>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col>
                                    <Button style={{width: "100%", padding: 6}} onClick={e => downloadApp(e)}>
                                <span className="btn-inner--icon">
                                    <img
                                        style={{width: 20}}
                                        alt="..."
                                        src={require("assets/img/icons/common/apple.svg").default}
                                    />
                                </span>

                                        <span className="btn-inner--icon">
                                    <img
                                        style={{width: 20}}
                                        alt="..."
                                        src={require("assets/img/icons/common/android.svg").default}
                                    />
                                </span>

                                    </Button>
                                </Col>
                            </Row>

                            {/*{accountType == "b" || accountType == "c" ?*/}
                            {accountType == "b" ?
                                (<Form role="form" onSubmit={e => handleSubmit(e)}>
                                    {accountType != "c" &&
                                    <Row>
                                        <Col lg="12">
                                            <FormGroup>
                                                <label
                                                    className="form-control-label text-light"
                                                    htmlFor="input-type"
                                                >
                                                    {commonStrings.business.business_type}
                                                </label>
                                                <Select
                                                    // theme={(theme) => ({
                                                    //     ...theme,
                                                    //     colors: {
                                                    //         ...theme.colors,
                                                    //         text: 'white',
                                                    //         primary: 'gray',
                                                    //     },
                                                    // })}
                                                    style={{
                                                        position: 'absolute',
                                                        top: '50%',
                                                        transform: 'translateY(-50%)',
                                                    }}
                                                    placeholder={commonStrings.select}
                                                    className="form-control-alternative"
                                                    value={bType}
                                                    onChange={handleTypeSelected}
                                                    options={businessHelper.businessTypes()}
                                                />
                                            </FormGroup>
                                        </Col>

                                    </Row>
                                    }
                                    <FormGroup className="mt-4">
                                        <InputGroup className="input-group-alternative mb-3">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    {validation.name === true ?
                                                        (<i className="fas fa-address-card"/>) :
                                                        (<i className="fas fa-address-card text-danger"/>)
                                                    }
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                placeholder={accountType == "c" ? commonStrings.name : commonStrings.business.name} type="text" id="input-name"
                                                onChange={handleChange}/>
                                        </InputGroup>
                                    </FormGroup>
                                    <FormGroup>
                                        <InputGroup className="input-group-alternative mb-3">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>

                                                    {validation.email === true ?
                                                        (<i className="fas fa-envelope"/>) :
                                                        (<i className="fas fa-envelope text-danger"/>)
                                                    }
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input placeholder={commonStrings.email} type="email"
                                                   autoComplete="new-email"
                                                   id="input-email" onChange={handleChange}/>
                                        </InputGroup>
                                    </FormGroup>
                                    <FormGroup>
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    {validation.password === true ?
                                                        (<i className="fas fa-lock"/>) :
                                                        (<i className="fas fa-lock text-danger"/>)
                                                    }
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input placeholder={commonStrings.password} type="password"
                                                   autoComplete="new-password" id="input-password"
                                                   onChange={handleChange}/>
                                        </InputGroup>
                                    </FormGroup>
                                    <div className="text-muted font-italic">
                                        {/*<small>*/}
                                        {/*  password strength:{" "}*/}
                                        {/*  <span className="text-success font-weight-700">{passwordStrength}</span>*/}
                                        {/*</small>*/}
                                    </div>
                                    <Row className="my-4">
                                        <Col xs="12">
                                            <div className="custom-control custom-control-alternative custom-checkbox">
                                                <input
                                                    className="custom-control-input"
                                                    id="input-pp-cb"
                                                    onChange={handleChange}
                                                    type="checkbox"
                                                />
                                                <label
                                                    className="custom-control-label"
                                                    htmlFor="input-pp-cb"
                                                >
                                                <span className="text-muted">
                                                  {commonStrings.agree_with}{" "}
                                                    <a href="#https://app.openmanagerapp.com/privacypolicy" onClick={() => goToPP()}>
                                                    {commonStrings.privacy_policy}
                                                    </a>
                                                </span>
                                                </label>
                                            </div>
                                        </Col>
                                    </Row>
                                    <div className="text-center">
                                        <Button className="mt-4" color="yellowopen" type="submit"
                                                disabled={!validationCleared() || formData.ppConfirmed !== true}
                                        >
                                            {commonStrings.create_account}
                                        </Button>
                                    </div>
                                </Form>)
                                :
                                (<ClientAppComponent/>)
                            }
                        </CardBody>
                    </Card>
                    <Row className="mt-3">
                        <Col xs="6">
                            <a
                                className="text-light"
                                href="#password_reset"
                                onClick={e => goToPasswordReset(e)}
                            >
                                <small>{commonStrings.forgot_password}</small>
                            </a>
                        </Col>
                        <Col className="text-right" xs="6">
                            <a
                                className="text-light"
                                href="#login"
                                onClick={e => goToLogin(e)}
                            >
                                <small>{commonStrings.login}</small>
                            </a>
                        </Col>
                    </Row>
                </LoadingOverlay>

            </Col>
        </>
    );

    function localize() {
        commonStrings.setLanguage(locale);
        // alertStrings.setLanguage(loc);
        // resourceStrings.setLanguage(loc);
    }
};

export default RegisterF;
